"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledScheduleAppointmentAside = exports.StyledScheduleAppointmentFixedMobileFooter = exports.LoadingBookingOptionsMessage = exports.LoadingCard = exports.AvailableWithinDaysText = exports.BookingButtonWrapper = exports.AvailabilityModeBookingContent = exports.BookingButtonModeBookingContent = exports.BookingHeader = exports.BookingSectionContainer = exports.BookingAsideContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const constants_1 = require("../../lib/constants");
exports.BookingAsideContainer = styled_1.default.aside `
  padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')};

  @media screen and (max-width: ${constants_1.BREAKPOINTS.small}px) {
    padding: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  }

  @media screen and (max-width: ${constants_1.BREAKPOINTS.large - 1}px) {
    display: none;
  }

  @media screen and (min-width: ${constants_1.BREAKPOINTS.large}px) {
    display: block;
    margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_large')};
    background: ${(0, ui_theme_1.fromTheme)('color_background')};
    border-radius: ${(props) => (0, ui_theme_1.fromTheme)('provider_profile_border_radius')(props)};
    border: ${(props) => `${(0, ui_theme_1.fromTheme)('provider_profile_border_style')(props)} ${(0, ui_theme_1.fromTheme)('provider_profile_color_border')(props)} ${(0, ui_theme_1.fromTheme)('provider_profile_border_width')(props)}`};
    box-shadow: ${(props) => (0, ui_theme_1.fromTheme)('provider_profile_box_shadow')(props)};
    -webkit-box-shadow: ${(props) => (0, ui_theme_1.fromTheme)('provider_profile_box_shadow')(props)};
    -moz-box-shadow: ${(props) => (0, ui_theme_1.fromTheme)('provider_profile_box_shadow')(props)};
  }

  @media print {
    display: none;
  }
`;
exports.BookingSectionContainer = styled_1.default.section `
  padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')};

  @media print {
    display: none;
  }

  @media screen and (min-width: ${constants_1.BREAKPOINTS.large}px) {
    display: block;
    margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_large')};
  }

  ${(props) => props.showBorder &&
    `
    background: ${(0, ui_theme_1.fromTheme)('color_background')(props)};
    border-radius: ${(0, ui_theme_1.fromTheme)('provider_profile_border_radius')(props)};
    border: ${(0, ui_theme_1.fromTheme)('provider_profile_border_style')(props)} ${(0, ui_theme_1.fromTheme)('provider_profile_color_border')(props)} ${(0, ui_theme_1.fromTheme)('provider_profile_border_width')(props)};
    box-shadow: ${(0, ui_theme_1.fromTheme)('provider_profile_box_shadow')(props)};
    -webkit-box-shadow: ${(0, ui_theme_1.fromTheme)('provider_profile_box_shadow')(props)};
    -moz-box-shadow: ${(0, ui_theme_1.fromTheme)('provider_profile_box_shadow')(props)};
    `}
`;
exports.BookingHeader = (0, styled_1.default)('h2') `
  margin: 0 0 ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0;
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bolder')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
`;
exports.BookingButtonModeBookingContent = (0, styled_1.default)('div') `
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  overflow: hidden;
  padding: ${(0, ui_theme_1.fromTheme)('spacing_xsmall')} 0;

  @media screen and (min-width: ${constants_1.BREAKPOINTS.large}px) {
    display: block;
  }
`;
exports.AvailabilityModeBookingContent = (0, styled_1.default)('div') `
  display: block;
`;
exports.BookingButtonWrapper = (0, styled_1.default)('div') `
  flex: 0 1 50%;

  button.provider-booking-button,
  a.provider-booking-button {
    white-space: nowrap;
    width: 100%;
    margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};

    > span.button-text {
      font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
    }

    // add white border if screen less than large width
    @media screen and (max-width: ${constants_1.BREAKPOINTS.large}px) {
      border: 1px solid white;
      margin: 0 0 0 ${(0, ui_theme_1.fromTheme)('spacing_small')};
      width: calc(100% - ${(0, ui_theme_1.fromTheme)('spacing_small')});
    }
  }
`;
exports.AvailableWithinDaysText = (0, styled_1.default)('div') `
  text-align: center;
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  white-space: nowrap;

  @media screen and (max-width: ${constants_1.BREAKPOINTS.large}px) {
    margin-top: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  }

  svg {
    display: none;
  }

  span {
    vertical-align: middle;
  }

  @media screen and (min-width: ${constants_1.BREAKPOINTS.large}px) {
    font-size: ${(0, ui_theme_1.fromTheme)('font_size_small')};
    margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_small')};
    svg {
      display: inline;
      vertical-align: middle;
      color: ${(0, ui_theme_1.fromTheme)('color_icon_green')};
      margin-right: ${(0, ui_theme_1.fromTheme)('spacing_xsmall')};
    }
  }
`;
exports.LoadingCard = (0, styled_1.default)('div') `
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;
  background-color: inherit;

  > div {
    margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  }
`;
exports.LoadingBookingOptionsMessage = styled_1.default.div `
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
`;
exports.StyledScheduleAppointmentFixedMobileFooter = styled_1.default.div `
  // displayed as fixed footer on mobile screens
  width: 100%;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-top: ${(props) => `${(0, ui_theme_1.fromTheme)('provider_profile_border_style')(props)} ${(0, ui_theme_1.fromTheme)('provider_profile_color_border')(props)} ${(0, ui_theme_1.fromTheme)('provider_profile_border_width')(props)}`};

  @media screen and (min-width: ${constants_1.BREAKPOINTS.large}px) {
    display: none;
  }
`;
exports.StyledScheduleAppointmentAside = styled_1.default.div `
  grid-area: action;
`;
//# sourceMappingURL=styles.js.map